exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/subdomains/codebnb/hanoigo/public_html/client_user/node_modules/postcss-loader?{"ident":"postcss"}!/var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles